import styled from 'styled-components';

/**
 * Styled Component for Terminal Square Cursor
 */
export const TermSquare = styled.div`
  display: inline-block;
  background-color: white;
  height: 1em;
  width: 0.5em;
  margin-left: 5px;
  margin-top: 0;
  margin-bottom: 0;
`;